export const generateCodeVerifier = (): string => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
};

export const generateCodeChallenge = async (
  verifier: string
): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...Array.from(new Uint8Array(digest))))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const isTokenExpired = (token: string) => {
  if (!token) {
    return true;
  }

  const [, encodedPayload] = token.split(".");

  if (!encodedPayload) {
    return true;
  }

  const payload = JSON.parse(atob(encodedPayload));
  const now = Date.now() / 1000;

  return now > payload.exp;
};
